import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import bidsNew from "../components/bidsNew";
import Party from "../components/Party";
import Survey from "../components/Survey";
import State from "../components/State";
import Culture from "../components/Culture";
import Relation from "../components/Relation";
import firm from "../components/firm"
Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path:'/bidsNew',
      name:'bidsNew',
      component:bidsNew
    },
    {
      path:'/Party',
      name:'Party',
      component:Party
    },
    {
      path:'/Survey',
      name:'Survey',
      component:Survey
    },
    {
      path:'/State',
      name:'State',
      component:State
    },
    {
      path:'/Culture',
      name:'Culture',
      component:Culture
    },
    {
      path:'/Relation',
      name:'Relation',
      component:Relation
    },
    {
      path:'/firm',
      name:'firm',
      component:firm
    },
  ]
})

// 添加全局导航守卫，确保每次路由切换时重置body样式
router.beforeEach((to, from, next) => {
  // 重置所有可能阻止滚动的样式
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
  document.body.style.position = '';
  document.body.style.height = '';
  
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js